
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><strong parentName="p">{`Google und Apple`}</strong>{` haben sich auf die Arbeit von ETH und EPFL
`}<a parentName="p" {...{
        "href": "https://techcrunch.com/2020/04/24/apple-and-google-update-joint-coronavirus-tracing-tech-to-improve-user-privacy-and-developer-flexibility/"
      }}>{`gestützt`}</a>{`,
um ihre gemeinsamen Proximity-Tracing-Programmierschnittstellen (APIs) zu
entwerfen. Wenn die nötigen Updates auf den Geräten installiert sind,
funktionieren kompatible Apps reibungslos und können miteinander kommunizieren.
Eine solche Kooperation zwischen beiden Tech-Giganten ist historisch – die
beiden ETH-Präsidenten Joël Mesot und Martin Vetterli
`}<a parentName="p" {...{
        "href": "https://www.nzz.ch/meinung/die-wissenschaft-und-die-lektionen-einer-pandemie-ld.1550928"
      }}>{`zeigten sich`}</a>{`
im April entsprechend stolz.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;